module.exports = __webpack_public_path__ + "img/Blog-Image.231fbc79.png";